// const LogisticsTeam

import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
import { ArrowBack } from "@material-ui/icons";
import PODetail from "../NewInvoice/Tables/PoDetail_Table";
import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  getImportPoData,
  updateIPInvoiceByImport,
  updateLogisticsInvoice,
} from "../actions";
import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { demandType, category, invoiceType } from "../../Home/constant";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
// import PaymentDetail from "../Components/PaymentDetails/PaymentDetail";
import PaymentDetail from "../Components/PaymentDetails/PaymentDetail.js";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserRoles } from "../../Home/actions";
import getParameterByName from "../../../Functions/functions";
import TaxTable_Short from "../NewInvoice/Tables/Tax_Table_Short";
import GL_Table_ProcessInvoice from "../NewInvoice/Tables/GL_Table_ProcessInvoice";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import { addZeroes } from "../../../Functions";
import OldDateWarning from "../NewInvoice/InvoiceGuidLines/OldDateWarning";
import TaxTable_Short_Import from "../NewInvoice/Tables/Tax_Table_Short_import";
import PoDetail_Table_Import from "../NewInvoice/Tables/PoDetail_Table_Import";
import Vendor_Table from "../NewInvoice/Tables/Vendor_Table";
import PaymentImport from "../NewInvoice/Payment/PaymentImport";
import WarningBox from "../Components/WarningBox";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import PoDetail_Table_V2 from "../NewInvoice/Tables/PoDetail_Table_V2";
import PODetailTableLogistic from "../NewInvoice/Tables/POTableForLogistic.js";
import axios from "axios";
import DebugDialog from "../NewInvoice/InvoiceDialogs/DebugDialog";
import Heading from "../../../StyledComponents/Heading/Heading";
const useStyles = makeStyles(dashboardStyle);

const LogisticsTeam = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      if (location?.state?.msg) {
        setSuccessMessage(location?.state?.msg);
        navigate(
          {
            pathname: location.pathname,
            search: location.search,
          },
          { replace: true }
        );
      }
    }, 2000);
  }, []);
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const status = getParameterByName("status");
  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };

  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [Post ,setPost] = useState(true)
  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");

  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);

  // const [isLoading, setIsLoading] = useState(true);

  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
  });
  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    po_Date: new Date().toString(),
    plant_Code: "",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: "",
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,

    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    cnic: "",

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: "",
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    due_Date: new Date(),

    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    // for Payment detail ("invoice_Payment" for po normal isInititor invoice).
    // ("invoice_Payment_Details" for import invoice) (will chnage).
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table data (invoice_TaxDetails for po normal isInititor invoice)
    // ("invoice_Tax_Details" for import invoice) (will chnage).
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    invoiceDebugData_List: [],
    verified: false,
  });

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [importPaymentDetail, setImportPaymentDetail] = useState({
    invoice_Payment_Details: [],
  });
  const [newFormState, setNewFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    //   for import invoice (extra field)
    currency: "",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    currency: "",

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "", // D/C (debit/ credit)
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    invoiceDebugData_List: [],
    verified: false,
  });
  const [po_dn_State, setPo_dn_State] = useState("DN");

  const [debitBalance, setDebitBalance] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);

  const [invoiceTaxDetail, setInvoiceTaxDetail] = useState({
    invoice_TaxDetails: [],
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [totalGrnAmount, setTotalGrnAmount] = useState(0);
  const [balance, setBalance] = useState(0);

  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [gLAccountTotal, setGLAccountTotal] = useState(0);
  const [temp_ActualPoDetail, setTemp_ActualPoDetail] = useState({
    invoicePORef_List: [
      // {
      //   po_Ref_Id: 0,
      //   reF_DOC_IT: "",
      //   val_Loccur: 0, // GRN amount
      //   currency: "", // currency
      //   quantity: "", // GRN quantity
      //   delivUnit: "",
      //   poNumber: "", // poNumber
      //   poItem: "", //  item #
      //   poItemText: "",
      //   refDoc: "", // GRN No
      //   plant: "",
      //   reF_DOC_NO: "",
      //   reF_DOC_NO_LONG: "",
      //   assetNumber: "",
      //   kschl: "",
      //   vText: "",
      //   invoice_Id: 0,
      //   created_by: "",
      //   created_on: new Date(),
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: "", // consumed Amount
      //   balancE_QTY: "",
      //   balancE_VAL: "",
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   conD_ST_NO: "",
      //   conD_COUNT: "",
      //   doC_YEAR: "",
      //   sheeT_ITEM: "",
      //   dN_NO: "",
      //   seQ_NO: "",
      //   disT_IND: "",
      //   ordeR_UNIT: "",
      //   ordeR_QTY: "",
      //   sO_NO: "",
      //   sO_ITEM: "",
      // },
    ],
  }); // this temp_ActualPoDetail is used to load data on po detail table on the page.

  const [copyOfPoDetail, setCopyOfPoDetail] = useState({
    copyInvoicePORef_List: [],
  }); // this is used to save the copy of data, when user enter po and dn number. and when get po from getInvoiceByInvoiceIdAndRoleId
  const [poLoading, setPoTableLoading] = useState(false);

  const [openDebugDialog, setOpenDebugDialog] = useState(false);

  useEffect(() => {
    if (newFormState?.invoicePORef_List?.length > 0) {
      const asd = newFormState?.invoicePORef_List.map((x) => {
        x.selected = true;
        return x;
      });
      setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
        ...temp_ActualPoDetail,
        invoicePORef_List: asd,
      }));
      // let counts = 0;

      // for (let i = 0; i < newFormState?.invoicePORef_List?.length; i++) {
      //   const item = newFormState?.invoicePORef_List[i];
      //   counts = counts + parseFloat(item.inpuT_VAL);
      // }
      // setTotalGrnAmount(counts);
    }
  }, [newFormState.invoicePORef_List]);

  // to set po based true or false.
  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setNewFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }
    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };

  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    clearState(setFormState);
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };

  const submitHandler = () => {
    const data = {
      invoice_Id: parseInt(newFormState.invoice_Id),
      updated_By: "",
      additionalDocIds:
        newFormState?.additionalDocIds.length > 0
          ? newFormState?.additionalDocIds
          : [""],
      comments: newFormState?.comments,
      // invoicePORef_List: newFormState?.invoicePORef_List,
      invoicePORef_List: newFormState?.invoicePORef_List.map((item) => ({
        ...item,
        inpuT_QTY: item?.inpuT_QTY?.toString() || "0",
        inpuT_VAL: item?.inpuT_VAL?.toString() || "0",
      })),
      invoiceDebugData_List: newFormState?.invoiceDebugData_List,
    };
    updateLogisticsInvoice(
      data,
      newFormState,
      setErrorMessage,
      setSuccessMessage,
      setAttachInvoiceLoading,
      navigate,
      roles
    );
    setOpenWarningBox(false);
  };

  const [isFormStateStoped, setIsFormStateStoped] = useState(false);

  useEffect(() => {
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "postingKey",
      "postingKey",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("sglInd", "sglInd", setFormState, setMultipleData);
    getRefrenceDataList("tType", "tType", setFormState, setMultipleData);

    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("Currency", "currency", setFormState, setMultipleData);
    getUserRoles(setRoles, setRolesLoading);

    if (invoicePayload && role) {
      getInvoiceByInvoiceIdAndRoleId(
        invoicePayload,
        role,
        setFormState,
        () => { }
      );
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
      // if (!formState.isImport) {
      getAllInvoiceDetailByInvoiceId(
        setFormState,
        setMultipleData,
        invoicePayload?.Invoice_id,
        () => { },
        () => { },
        "",
        () => { }
      );
      // }
    }
  }, []);
  const [po_Loading, setPo_Loading] = useState(false);

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }
    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    setAttachmentURL(formState?.invoice_attachment);
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
        newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);

  useEffect(() => {
    setNewFormState(formState);
    setNewFormState((newFormState) => ({
      ...newFormState,
      additionalDocIds: [],
    }));
  }, [formState]);

  //  used for show taxdetail when invoice is created by import.

  //  used for show taxdetail when invoice is created by import.
  useEffect(() => {
    if (formState?.taxCard_List?.length > 0 && formState.isImport) {
      let tempArray = [];
      for (let i = 0; i < formState?.taxCard_List?.length; i++) {
        const item = formState?.taxCard_List[i];
        const obj = {
          taxId: 0,
          invoice_Id: invoicePayload?.Invoice_id,
          taxType: item?.taxType,
          taxCode: item?.taxCode,
          amount: formState.invoice_Amount,
          comments: "",
          created_By: "",
          created_On: new Date(),
          updated_By: "",
          updated_On: new Date(),
          taxCardId: 0,
        };
        tempArray.push(obj);
      }
      setInvoiceTaxDetail((formState) => ({
        ...formState,
        invoice_TaxDetails: tempArray,
      }));
    }
  }, [formState?.taxCard_List]);

  useEffect(() => {
    let total = 0;
    if (formState.invoice_Accounts.length > 0) {
      for (let index = 0; index < formState.invoice_Accounts.length; index++) {
        const item = formState.invoice_Accounts[index];
        total = parseFloat(item.amount ? item?.amount : item?.Amount) + total;
      }
      setGLAccountTotal(total);
    }
  }, [formState?.invoice_Accounts]);

  // invoice_attachment: "",
  // additionalDocIds: "", // paths

  // useEffect(() => {
  //   if (!changed && formState?.additionalDocIds.length > 0) {
  //     setNewFormState((newFormState) => ({
  //       ...newFormState,
  //       additionalDocIds: [],
  //     }));
  //     setChanged(true);
  //   }

  // }, [formState.additionalDocIds]);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  const confirmHandler = (e) => {
    e.preventDefault();
    setOpenWarningBox(true);
  };

  const [temparary_PoDetail, setTemparary_PoDetail] = useState({
    invoicePORef_List: [],
  }); // this temparary_PoDetail will load in pop - table
  const [search_val, setSearch_val] = useState("");
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setSearch_val("");
    setTemparary_PoDetail((temparary_PoDetail) => ({
      ...temparary_PoDetail,
      invoicePORef_List: [],
    }));
  };

  const submitPopup = () => {
    // setFormState((formState) => ({
    //   ...formState,
    //   invoicePORef_List: [
    //     ...temp_ActualPoDetail.invoicePORef_List,
    //     ...selected_PoRec.invoicePORef_List,
    //   ],
    // }));

    // add the selected po records from pop up to main table
    let filteredData = temparary_PoDetail.invoicePORef_List.filter(
      (data) => data.selected === true
    );
    filteredData = [...temp_ActualPoDetail.invoicePORef_List, ...filteredData];
    setTemp_ActualPoDetail((temp_ActualPoDetail) => ({
      ...temp_ActualPoDetail,
      invoicePORef_List: filteredData,
    }));
    handleClose();
    setSearch_val("");
    setTemparary_PoDetail((temparary_PoDetail) => ({
      ...temparary_PoDetail,
      invoicePORef_List: [],
    }));
  };

  const multiVal = (e) => {
    setSearch_val(e.target.value);
    // setMultiValLoading(true);
    let config = {};
    if (po_dn_State === "PO") {
      config = {
        method: "get",
        url: `http://i2p-sfg.genial365.com/sap-endpoint/get-multiple-po-data/${e.target.value}`,
        // params: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      let d = {};
      if (formState?.isLogistics) {
        d = {
          po_no: formState?.invoice_Type === "ITN" ? e.target.value : "",
          dn_no: formState?.invoice_Type === "DN" ? e.target.value : "",
        };
      } else {
        d = {
          po_no: "",
          dn_no: e.target.value,
        };
      }
      config = {
        method: "POST",
        url: `http://i2p-sfg.genial365.com/sap-endpoint/GetMultipleDNData_v1`,
        // params: data,
        data: d,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          "Content-Type": "application/json",
        },
      };
    }

    axios(config)
      .then(function (response) {
        const parsed =
          po_dn_State === "PO" ? response?.data : JSON.parse(response?.data);
        setTemparary_PoDetail(() => ({
          invoicePORef_List: parsed?.map((item, index) => ({
            AssetNumber: item.AssetNumber,
            BALANCE_QTY: item.BALANCE_QTY,
            BALANCE_VAL: item.BALANCE_VAL,
            COND_COUNT: item.COND_COUNT,
            COND_ST_NO: item.COND_ST_NO,
            Currency: item.Currency,
            DIST_IND: item.DIST_IND,
            DN_NO: item.DN_NO,
            DOC_DATE: item.DOC_DATE,
            DOC_YEAR: item.DOC_YEAR,
            DelivUnit: item.DelivUnit,
            Dlvqty: item.Dlvqty,
            INVOICE_QTY: item.INVOICE_QTY,
            INVOICE_VAL: item.INVOICE_VAL,
            KSCHL: item.KSCHL,
            ORDER_QTY: item.ORDER_QTY,
            ORDER_UNIT: item.ORDER_UNIT,
            POItem: item.POItem,
            POItemText: item.POItemText,
            PONumber: item.PONumber,
            Plant: item.Plant,
            uniT_PRICE : item.UNIT_PRICE, 
            Poqty: item.Poqty,
            Quantity: item.Quantity,
            RefDoc: item.RefDoc,
            RefDocIT: item.RefDocIT,
            RefDocNo: item.RefDocNo,
            RefDocNoLong: item.RefDocNoLong,
            SEQ_NO: item.SEQ_NO,
            SHEET_ITEM: item.SHEET_ITEM,
            SHEET_NO: item.SHEET_NO,
            SO_ITEM: item.SO_ITEM,
            SO_NO: item.SO_NO,
            VText: item.VText,
            Val_Gr_Loc: item.Val_Gr_Loc,
            Val_Iv_Loc: item.Val_Iv_Loc,
            Val_Loccur: item.Val_Loccur,
            Vendor_Code: item.Vendor_Code,
            Vendor_Name: item.Vendor_Name,
            invoice_Id: Number(invoicePayload?.Invoice_id),
            selected: false,
          })),
        }));
        // setMultiValLoading(false);
      })
      .catch(function (error) {
        // setMultiValLoading(false);
      });
  };

  const gltotal = 0;
  useEffect(() => {
    let days = multipleData?.paymentTerms?.filter(
      (item) =>
        item.ReferenceCode === newFormState.invoice_Payment?.paymentTerms
    );
    let date = moment(newFormState?.invoice_Date).format("YYYY-MM-DD");

    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        dueOn: moment(date, "YYYY-MM-DD")
          .add(Number(days[0]?.ReferenceProp1), "days")
          .format("YYYY-MM-DD"),
      },
    }));

    //  newFormState?.invoice_Payment
  }, [
    newFormState?.invoice_Payment?.paymentTerms,
    newFormState?.invoice_Payment?.dueOn,
    newFormState?.invoice_Date,
  ]);

  useEffect(() => {
    // if (newFormState.IsImport && newFormState.IsPSID) {
    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        paymentMethod: "6",
        paymentMethSupp: "C",
      },
    }));

    // }
    // else if (newFormState.IsImport && !newFormState.IsPSID) {
    //   setNewFormState((formState) => ({
    //     ...formState,
    //     invoice_Payment: {
    //       ...formState?.invoice_Payment,
    //       paymentMethod: '3',
    //       paymentMethSupp: 'P'

    //     },
    //   }))
    // }
  }, []);
  return (
    <Card>
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 20px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>Logistic Team</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>



        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <Grid container style={{ marginTop: "1px", padding: "0px 4px" }}>
              {/* Submitter role */}
              <Grid item xs={12} sm={12} md={6} lg={6} mt={2}>
                <Typography style={{ color: "black" }}>
                  Submitter Role <span className={classes.asterisk}>*</span>
                </Typography>
                <Autocomplete
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "30px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      marginTop: "-4px", // Adjust this value to move the text up
                      fontSize: 15
                    },
                  }}
                  id="submitter_role"
                  options={roles}
                  size="small"
                  value={selectedRole}
                  getOptionLabel={(option) =>
                    (option !== "" && `${option?.roleName}`) || ""
                  }
                  loading={rolesLoading}
                  onChange={(event, newValue) => {
                    roleHandler(newValue);
                  }}
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {!formState.isImport && (
                <InvoiceCheckboxes
                  formState={formState}
                  setFormState={setFormState}
                  selectedRole="Logistic"
                  disabled={true}
                />
              )}
              {!formState.isImport && (
                <InvoiceRadioButtons
                  formState={formState}
                  setFormState={setFormState}
                  selectedRole="Logistic"
                  physicalOrEInvoice={physicalOrEInvoice}
                  poBasedState={poBasedState}
                  alignForAttachment={true}
                />
              )}

              <InvoiceTextField
                newFormState={formState}
                setNewFormState={setFormState}
                selectedRole="Logistic"
                disabled={true}
                poBasedState={poBasedState}
                showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
                showVendorCodeForImport={showVendorCodeForImport}
                invoice_attachmentRef={invoice_attachmentRef}
                additionalAttachmentRef={additionalAttachmentRef}
                setAttachInvoiceLoading={setAttachInvoiceLoading}
                //   setAttchmentFile_UI={setAttchmentFile_UI}
                //   attachmentFile_UI={attachmentFile_UI}
                physicalOrEInvoice={physicalOrEInvoice}
                changeHandler={changeHandler}
                alignForAttachment={true}
                setAttachmentURLList={setAttachmentURLList}
                attachmentURLList={attachmentURLList}
                setAttachmentURL={setAttachmentURL}
                showAttachmentsHandler={showAttachmentsHandler}
                setOpenInvalidWarningDate={setOpenInvalidWarningDate}
                multipleData={multipleData}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingLeft: "7px" }}
          >
            <Heading title="Attachment Preview">
              <span>
                {attachmentURL != ""
                  ? attachmentURL == formState?.invoice_attachment
                    ? " (Invoice Attachmnets)"
                    : "(Additional Documents)"
                  : null}
              </span>
            </Heading>
            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
            />
          </Grid>
        </Grid>

        <form onSubmit={confirmHandler} style={{ marginTop: "50 px" }}>
          {/* Comment History */}
          <CommentHistory
            commentsList={commentsList}
            commentsLoading={commentsLoading}
          />
          {/* po table */}

          <>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
              <DialogTitle>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Typography
                    variant="h4"
                    required
                    id="demo-row-radio-buttons-group-label"
                    style={{ margin: "20px 4px 0px 0px", color: "black" }}
                  >
                    <b>
                      {formState?.isLogistics
                        ? "DN Number/ ITN Number"
                        : "PO Number/ DN Number"}
                    </b>
                  </Typography>
                </Grid>
              </DialogTitle>
              <DialogContent>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  style={{ marginLeft: "4px" }}
                >
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      aria-label="gender"
                      name="gender1"
                      value={po_dn_State}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      // value={value}
                      onChange={(e) => {
                        setPo_dn_State(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value={formState?.isLogistics ? "ITN" : "PO"}
                        control={<Radio size="small" />}
                        label={
                          formState?.isLogistics ? "ITN Number" : "PO Number"
                        }
                      />
                      <FormControlLabel
                        value="DN"
                        control={<Radio size="small" />}
                        label="DN Number"
                      />
                    </RadioGroup>
                  </FormControl>
                  <TextField
                    id="outlined-basic"
                    label="Search"
                    variant="outlined"
                    value={search_val}
                    required
                    size="small"
                    onChange={multiVal}
                    style={{ marginTop: "4px" }}
                  />
                </Grid>

                {/* <DialogContentText> */}
                <PODetail
                  // selected_PoRec={selected_PoRec}
                  //setSelected_PoRec={setSelected_PoRec}
                  // setSelectedTotal={setSelectedTotal}
                  Invoice_id={invoicePayload?.Invoice_id}
                  formState={temparary_PoDetail}
                  setFormState={setTemparary_PoDetail}
                  disabled={true}
                  checkedBox={true}
                  deletee={false}
                // loading={multiValLoading}
                />
                {/* </DialogContentText> */}
              </DialogContent>
              {/* <Box
                    display="flex"
                    justifyContent={"flex-end"}
                    mt={2}
                    mb={2}
                    mr={5}
                  > */}
              <DialogActions>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={submitPopup}
                >
                  Submit
                </Button>
              </DialogActions>
              {/* </Box> */}
            </Dialog>
            {(formState?.pO_Based || formState?.isLogistics) && (
              <>
                <Grid container spacing={0} style={{ marginTop: "0px" }}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Heading title="PO Details" />

                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={() => setOpen(true)}
                    // style={{ display: disable ? "none" : "" ,marginLeft:"6px" }}
                    >
                      Add New
                    </Button>
                    {formState?.isLogistics && (
                      <Button
                        style={{ marginLeft: "10px" }}
                        color="secondary"
                        variant="contained"
                        onClick={() => setOpenDebugDialog(true)}
                      >
                        Debug
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={12}>
                    <PODetailTableLogistic
                      Invoice_id={invoicePayload?.Invoice_id}
                      setSelectedTotal={() => { }}
                      formState={newFormState}
                      setFormState={setNewFormState}
                      // formState={temp_ActualPoDetail}
                      // setFormState={setTemp_ActualPoDetail}
                      setFormState_v1={setNewFormState}
                      grn_No={formState.grn_No}
                      isLogistics={formState.isLogistics}
                      selectedRole={selectedRole}
                      copyOfPoDetail={copyOfPoDetail}
                      loading={poLoading}
                      disabled={false}
                      deletee={true}
                      checkedBox={true}
                      // edit={edit}
                      status={status}
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </>
          {/* clearing detail */}

          <Grid container style={{
            margin: "10px 0px", marginTop: '0px', padding: "0px 4px"
          }}>
            < Grid item xs={12} sm={12} md={3} lg={12} >
              <Typography style={{ color: "black" }}>
                comments:
                <span className={classes.asterisk}>*</span>
              </Typography>
              <TextField
                fullWidth
                multiline
                // rows={2}
                maxRows={4}
                // size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                name="comments"
                required
                value={newFormState.comments}
                onChange={changeHandler}
              />
            </Grid>
          </Grid>

          {/* 3 way check */}
          <Grid container>
          {Post && (
            <Grid item xs={12} sm={12} md={12} lg={12}>    
              <Button
                style={{ margin: "2px", color: "white" }}
                variant="contained"
                color="danger"
                onClick={() => navigate("/home")}
              >
                CANCEL
              </Button>

              {/* <Button
                  style={{ margin: "2px" }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setConfirmationMessage(
                      "Are you sure to send invoice to Invoice Receiver"
                    );
                    setStatusForPayload("SendToIRFromLogistic");
                    setConfirmationModal(true);
                  }}
                >
                  Send Back
                </Button> */}

              <Button
                style={{ margin: "2px" }}
                variant="contained"
                color="inherit"
                type="submit"
                onClick={() => {
                  setStatusForPayload("SendToIRFromLogistic");
                }}
              >
                Return to IR
              </Button>
           
            </Grid>
            )}
          </Grid>
        </form>
      </CardBody >
      {openInvalidWarningDate && (
        <OldDateWarning
          open={openInvalidWarningDate}
          close={() => setOpenInvalidWarningDate(false)}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal}
          close={() => setConfirmationModal(false)}
          message={confirmationMessage}
          submit={() =>
            changeInvoiceStatus(
              formState.invoice_Id,
              statusForPayload,
              setConfirmationModal,
              setAttachInvoiceLoading,
              setSuccessMessage,
              setErrorMessage,
              navigate,
              newFormState?.comments,
              "",
              setPost,
            )
          }
          loading={attachInvoiceLoading}
        />
      )}

      {
        openDebugDialog && (
          <DebugDialog
            open={openDebugDialog}
            debugData={formState}
            // debugData={debugData}
            setDebugData={setNewFormState}
            handleClose={() => setOpenDebugDialog(false)}
            status={status}
          />
        )
      }

      {
        openInvoiceGuideLine && (
          <InvoiceGuideLine
            open={openInvoiceGuideLine}
            close={setOpenInvoiceGuideLine}
          />
        )
      }
      {
        successMessage && (
          <CustomSnackbar
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )
      }
      {
        errorMessage && (
          <CustomSnackbar
            open={errorMessage !== ""}
            message={errorMessage}
            handleClose={() => setErrorMessage("")}
            variant="error"
          />
        )
      }
      {
        openWarningBox && (
          <WarningBox
            open={openWarningBox}
            close={() => setOpenWarningBox(false)}
            submit={submitHandler}
            message="Are you sure to send invoice to Invoice Receiver"
          />
        )
      }
    </Card >
  );
};

export default LogisticsTeam;
